export const Filter = {
    stad: 'stad',
    merken: 'merken',
    sorteer_op: 'sorteer_op',
    sorteer_richting: 'sorteer_richting',
    page: 'page',
    latitude: 'latitude',
    longitude: 'longitude'
}